export * from 'server/models/BerthReservationSelf';


// WEBPACK FOOTER //
// ./data/models/BerthReservationSelf.ts